module.exports = __webpack_public_path__ + "img/icon-4.28be0011.png";